import React from "react";
import LegalPage from "components/Legal/LegalPage.jsx";

export default function DisclaimerPage() {
    return (
        <LegalPage title="Disclaimer">
            <h2>Keine Anlageberatung</h2>
            <p>
                Die auf kimat-online bereitgestellten Inhalte, Daten, Signale,
                Kennzeichnungen, Scores und KI-generierten Einschätzungen dienen
                ausschließlich allgemeinen Informationszwecken.
            </p>

            <p>Sie stellen insbesondere keine dar:</p>
            <ul>
                <li>Anlageberatung</li>
                <li>Anlagevermittlung</li>
                <li>Finanzanalyse im rechtlichen Sinne</li>
                <li>Vermögensverwaltung</li>
                <li>Aufforderung zum Kauf, Verkauf oder Halten von Finanzinstrumenten</li>
            </ul>

            <h2>Keine Gewähr</h2>
            <p>
                Wir übernehmen keine Gewähr für Richtigkeit, Vollständigkeit, Aktualität
                oder wirtschaftliche Eignung der Inhalte.
            </p>

            <h2>Eigenverantwortung</h2>
            <p>Investitionsentscheidungen treffen Nutzer ausschließlich in eigener Verantwortung.</p>

            <h2>Keine Erfolgsgarantie</h2>
            <p>
                Frühere Entwicklungen, Trends oder KI-basierte Einschätzungen sind kein
                verlässlicher Indikator für zukünftige Entwicklungen.
            </p>
        </LegalPage>
    );
}